import React, { FunctionComponent, useState } from 'react'
import { useAppRouter, useSelectedPaymentType, useShowAffIdvModal, useShowIdvModal } from '../../../state'
import { useMonitoringWithEnduringEventProperties } from '../../../integrations/monitoring'
import { TrackingEvent } from '../../../model/monitoring'
import { PaymentType } from '@afterpay/types'
import { Route } from '../../../config/router'
import styles from './style.module.css'
import { Button, useModal } from '@afterpaytouch/core'
import { useTranslation } from '../../../utils/convergence'
import { IdentityVerificationModal } from '../../IdentityVerificationModal'
import { IdentityVerificationModalKey } from '../../../model'

interface PaymentTypesContinueButtonProps {
  setPbiOptionSelected: (bool: boolean) => void
}

export const PaymentTypesContinueButton: FunctionComponent<PaymentTypesContinueButtonProps> = ({ setPbiOptionSelected }) => {
  const { t } = useTranslation()
  const selectedPaymentType = useSelectedPaymentType()
  const router = useAppRouter()
  const { logEvent } = useMonitoringWithEnduringEventProperties()
  const showIDVModal = useShowIdvModal()
  const showAffIdvModal = useShowAffIdvModal()
  const [clicked, setClicked] = useState<boolean>(false)
  const { showModal } = useModal(IdentityVerificationModalKey)

  const disableContinueButton = selectedPaymentType === undefined || clicked

  const clickContinue = async (): Promise<void> => {
    setClicked(true)
    logEvent(TrackingEvent.PRESSED_CL_ENTRY_PAGE_CONTINUE_BUTTON)

    if (selectedPaymentType === PaymentType.PBI) {
      if (showAffIdvModal) {
        showModal()
      } else {
        setPbiOptionSelected(true)
      }
      return
    }

    if (showIDVModal) {
      showModal()
    } else {
      router.push(Route.PAYMENT_OPTIONS)
    }
  }

  return (
    <>
      <div className={styles.continueButton}>
        <Button padding='Fluid' loading={clicked} disabled={disableContinueButton} onClick={clickContinue} testNameSpace='payment-types'>
          {t('consumerLending:paymentOptions:continue')}
        </Button>
      </div>
      <IdentityVerificationModal setClicked={setClicked} setPbiOptionSelected={setPbiOptionSelected} />
    </>
  )
}
